import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NSUrlsConstants } from '@ruby/configs/urls.constants';
import {
  IGuaranteeHistory,
  IGuaranteeResponse,
  IGuaranteesConfirmation,
  IGuaranteesRequest,
  IMultiGuaranteeRequest,
  IUpdateStorageGuaranteeResponse
} from '@ruby/shared/models/guarantees/guarantees.interface';

@Injectable({
  providedIn: 'root'
})
export class GuaranteesService {

  constructor(private http: HttpClient) {}

  /**
   * Get Storage Guarantees
   *
   * @summary Gets Storage Guarantees
   * @param request: Partial<IGuaranteesRequest>
   * @returns Observable<IGuaranteResponse | never>
   */
  getStorageGuarantees(request: Partial<IGuaranteesRequest>): Observable<IGuaranteeResponse | never> {
    return this.http.post(NSUrlsConstants.storageGuaranteeBaseUrl, request).pipe(map(response => response as IGuaranteeResponse));
  }

  /**
   * Get Lift Guarantees
   *
   * @summary Gets Lift Guarantees
   * @param request: Partial<IGuaranteesRequest>
   * @returns Observable<IGuaranteResponse | never>
   */
  getLiftGuarantees(request: Partial<IGuaranteesRequest>): Observable<IGuaranteeResponse | never> {
    return this.http.post(NSUrlsConstants.liftGuaranteeBaseUrl, request).pipe(map(response => response as IGuaranteeResponse));
  }

  /**
   * Update Storage Guarantee
   *
   * @summary Updates Multiple Storage Guarantee
   * @param request : IMultiGuaranteeRequest
   * @returns Observable<Array<IUpdateStorageGuaranteeResponse> | never>
   * @param request
   */
  updateStorageGuarantee(request: IMultiGuaranteeRequest): Observable<Array<IUpdateStorageGuaranteeResponse> | never> {
    return this.http.put(NSUrlsConstants.storageGuaranteeBaseUrl, request).pipe(map((response) => response as Array<IUpdateStorageGuaranteeResponse>));
  }

  /**
   * Update Lift Guarantee
   *
   * @summary Updates Lift Guarantee
   * @param request: IGuaranteesConfirmation
   * @returns Observable<void | never>
   */
  updateLiftGuarantee(request: IGuaranteesConfirmation): Observable<void | never> {
    return this.http.put(NSUrlsConstants.liftGuaranteeBaseUrl, request).pipe(map(() => undefined));
  }

  /**
   * Load Storage Guarantee History
   *
   * @summary Load Storage Guaranty History
   * @param chargeId: string
   * @returns Observable<Array<IGuaranteeHistory | never>>
   */
  loadStorageGuaranteeHistory(chargeId: string): Observable<Array<IGuaranteeHistory | never>> {
    return this.http.get(`${ NSUrlsConstants.guaranteesHistory }/${ chargeId }`).pipe(map(response => response as Array<IGuaranteeHistory>));
  }
}
